import React from 'react';
import { FiPlus, FiX } from 'react-icons/fi';

// Procurement / Assembly activities must carry product lines.
export const PRODUCT_TYPES = ['procurement', 'assembly'];
export const needsProducts = (type) => PRODUCT_TYPES.includes(type);

export const emptyLine = () => ({ product_id: '', qty: '' });

export function linesFromTask(task) {
  return (task?.products || []).map((p) => ({ product_id: String(p.product_id), qty: String(p.qty) }));
}

export function lineIsComplete(l) {
  return l.product_id !== '' && Number(l.qty) > 0;
}

// Returns '' when OK, else a message explaining what is missing.
export function linesProblem(lines) {
  const filled = lines.filter((l) => l.product_id !== '' || l.qty !== '');
  if (!filled.length) return 'Add at least one product';
  if (filled.some((l) => l.product_id === '')) return 'Choose a product on every line';
  if (filled.some((l) => !(Number(l.qty) > 0))) return 'Enter a quantity above 0 on every line';
  return '';
}

export function linesForSave(lines) {
  return lines.filter(lineIsComplete).map((l) => ({ product_id: Number(l.product_id), qty: Number(l.qty) }));
}

const supplyLabel = (m) => (m === 'make' ? 'Make' : 'Buy');

export function ProductLinesEditor({ type, lines, onChange, products, loadError, showProblem }) {
  const update = (i, key) => (e) => onChange(lines.map((l, j) => (j === i ? { ...l, [key]: e.target.value } : l)));
  const remove = (i) => onChange(lines.length === 1 ? [emptyLine()] : lines.filter((_, j) => j !== i));
  const problem = linesProblem(lines);
  return (
    <div className="field task-products">
      <label>{type === 'assembly' ? 'Products to assemble' : 'Products to procure'} <span className="task-products-req">*</span></label>
      {loadError && <div className="inline-error">{loadError}</div>}
      {!loadError && products.length === 0 && (
        <div className="task-products-note">No active products in Inventory yet. Add the product under Inventory → Store first.</div>
      )}
      {lines.map((l, i) => (
        <div className="task-products-line" key={i}>
          <select value={l.product_id} onChange={update(i, 'product_id')} aria-label={`Product ${i + 1}`}>
            <option value="">Select product…</option>
            {products.map((p) => (
              <option key={p.id} value={String(p.id)}>{p.name} · {supplyLabel(p.supply_method)}</option>
            ))}
          </select>
          <input type="number" min="0" step="any" value={l.qty} onChange={update(i, 'qty')}
            placeholder="Qty" aria-label={`Quantity ${i + 1}`} />
          <button type="button" className="btn btn-sm" title="Remove line" onClick={() => remove(i)}><FiX /></button>
        </div>
      ))}
      <button type="button" className="btn btn-sm task-products-add" onClick={() => onChange([...lines, emptyLine()])}>
        <FiPlus /> Add product
      </button>
      {showProblem && problem && <div className="task-products-problem">{problem}</div>}
    </div>
  );
}

const fmtQty = (q) => Number(q).toLocaleString('en-IN', { maximumFractionDigits: 2 });

export function ProductSummary({ task }) {
  if (!needsProducts(task.activity_type)) return null;
  const list = task.products || [];
  if (!list.length) {
    if (task.children?.length) return null;
    return <div className="task-products-summary"><span className="task-products-missing">Products not set</span></div>;
  }
  return (
    <div className="task-products-summary">
      {list.map((p) => `${p.product_name} × ${fmtQty(p.qty)}`).join(' · ')}
    </div>
  );
}
